import { SR_API_ACTION_PREQUALIFICATION_GET_BY_LISTING_ID } from 'api/actionTypes';

export default async function getByListingId({ state, apiClient }, { listingId }) {
  const statePath = ['prequalifications', 'byListingId', listingId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PREQUALIFICATION_GET_BY_LISTING_ID,
    state: state,
    payload: {
      listingId,
    },
    onSuccess(prequalifications) {
      state.set(statePath, prequalifications);
    },
  });
}
